module.exports = __webpack_public_path__ + "img/2-2-who-sales.414a779d.jpg";